import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const ExternalLink = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 5a1 1 0 01.117 1.993L11 7H5a1 1 0 00-.993.883L4 8v11a1 1 0 00.883.993L5 20h11a1 1 0 00.993-.883L17 19v-6a1 1 0 011.993-.117L19 13v6a3 3 0 01-2.824 2.995L16 22H5a3 3 0 01-2.995-2.824L2 19V8a3 3 0 012.824-2.995L5 5h6zm10-3h.02c.023 0 .046.002.07.004L21 2a1.008 1.008 0 01.617.213c.063.05.12.107.17.17l-.08-.09a1.008 1.008 0 01.286.59l.003.03.003.055L22 3v6a1 1 0 01-1.993.117L20 9V5.414l-9.293 9.293a1 1 0 01-1.497-1.32l.083-.094L18.584 4H15a1 1 0 01-.993-.883L14 3a1 1 0 01.883-.993L15 2h6z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default ExternalLink;
